import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { PlatformProvider } from "@/context/PlatformContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { LangProvider } from "@/context/LangContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute";
import Layout from "@/components/Layout";
import SallaInstallHandler from "@/components/SallaInstallHandler";
import OnboardingWelcome from "@/components/OnboardingWelcome";
import LandingPage from "@/pages/LandingPage";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import ContactPage from "@/pages/ContactPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import Dashboard from "@/pages/Dashboard";
import Analytics from "@/pages/Analytics";
import Preview from "@/pages/Preview";
import Import from "@/pages/Import";
import Products from "@/pages/Products";
import Branches from "@/pages/Branches";
import SyncLogs from "@/pages/SyncLogs";
import SettingsPage from "@/pages/Settings";
import AdminDashboard from "@/pages/Admin";
import StoreOptimizer from "@/pages/StoreOptimizer";
import { Toaster } from "@/components/ui/sonner";
import ImportHistory from "@/pages/ImportHistory";

function App() {
  return (
    <div className="App">
      <PlatformProvider>
        <ThemeProvider>
          <LangProvider>
            <AuthProvider>
          <BrowserRouter>
            {/* Auto-login handler for Salla App Store installs */}
            <SallaInstallHandler />
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />

              {/* Protected app routes */}
              <Route
                element={
                  <ProtectedRoute>
                    <OnboardingWelcome />
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/analytics" element={<Analytics />} />
                <Route path="/preview" element={<Preview />} />
                <Route path="/import" element={<Import />} />
                <Route path="/import/history" element={<ImportHistory />} />
                <Route path="/products" element={<Products />} />
                <Route path="/branches" element={<Branches />} />
                <Route path="/logs" element={<SyncLogs />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/optimizer" element={<StoreOptimizer />} />
                <Route
                  path="/admin"
                  element={
                    <AdminRoute>
                      <AdminDashboard />
                    </AdminRoute>
                  }
                />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster richColors position="top-center" dir="rtl" />
        </AuthProvider>
          </LangProvider>
        </ThemeProvider>
      </PlatformProvider>
    </div>
  );
}

export default App;
